export const module = {
  info: {
    name: 'voip-mrt-enterprise-trunk',
    caption: 'voip-mrt-enterprise-trunk',
    viewGroup: 'mrt-modules'
  },
  vuexModules: ['api', 'state'],
  mainRoute: '/cpanel',
  // noRoutes: true,
  sideMenu: {
    topSeparator: false,
    caption: 'Trunk',
    icon: 'el-icon-folder',
    routeName: 'module->voip-mrt-enterprise-trunk->create'
  }
}

export default module
